<template lang="pug">
.listing-feedback-item
  v-card.round-xl(outlined)
    .px-6.pt-6
      .d-flex.align-start
        .flex-grow-1
          .d-flex.align-center.mb-1
            .text-sm.font-semibold {{ name }}
            v-card.success100.success700--text.d-flex.align-center.px-1.ml-2.round-md(v-if="existingPatientBadge" outlined)
              v-icon.mr-1(color="success700" size="15") $yzi-check-verified-02
              .text-xs.font-normal.pr-1 Existing patient
            .d-flex.ml-3.flex-grow-1
              v-icon.mr-2(v-if="responseType === 'googleReview'" size="16") $yzi-google-icon
              star-generator(:totalStar="5" :star="star" :size="16" classes="mr-2")
          .text-xs.font-normal.neutral500--text {{ dateTime }}
        slot(name="itemAction")
      v-divider.my-4(v-if="comment || extra_fields_data")

    .px-6
      .mb-4.text-sm(v-if="comment") {{ comment }}
      div(v-for="item in extra_fields_data")
        .d-flex.mb-4
          feedback-icon-display.mr-4(:type="item.type")
          .mt-1
            .text-sm.neutral500--text.mb-1 {{ item.name }}
            div(v-if="typeof item.value === 'object'")
              template(v-if="item.type === 'address'")
                .text-sm {{ processAddress(item.value) }}
              badge.mr-2.text-sm(v-else v-for="val in item.value" :label="val" :key="val")
            .text-sm(v-else) {{ item.value }}
            
    listing-response-item.mt-3(v-if="response && !isEditingResponse" :responseType="responseType" :response="response" :rightBtnText="$t('delete')" :leftBtnText="$t('edit')" :rightBtnLoading="isDeletingResponse" @rightBtnClicked="$emit('deleteResponse')" @leftBtnClicked="$emit('editResponse')")
    listing-assign-item(v-if="labels && labels.length && !isEditingResponse" :labels="labels" :rightBtnText="$t('delete')" :leftBtnText="$t('edit')" @rightBtnClicked="$emit('deleteAssignee')" @leftBtnClicked="$emit('editAssignee')")

    v-divider.my-4
    .d-flex.justify-end.ma-4(v-if="!overrideBottomView" :class="[{ 'flex-column': isMobileScreen }]")
      template(v-if="leftBtnText")
        v-tooltip(v-if="leftBtnTooltipText" top color="black" content-class="black tooltip-top-arrow" max-width="250px" open-delay="200")
          template(v-slot:activator="{ on, attrs }")
            v-btn.button-sm(v-bind="attrs" v-on="on" outlined :class="[isMobileScreen ? 'mb-4' : 'mr-4']" @click="$emit('leftBtnClicked')") {{ leftBtnText }}
          .c1.white--text {{ leftBtnTooltipText }}
        v-btn.button-sm(v-else outlined :class="[isMobileScreen ? 'mb-4' : 'mr-4']" @click="$emit('leftBtnClicked')") {{ leftBtnText }}
      v-btn.button-sm(outlined :class="[isMobileScreen ? 'mb-4' : 'mr-4']" @click="$emit('middleBtnClicked')" :disabled="middleBtnDisabled") {{ middleBtnText }}
      v-btn.button-sm(color="neutral700" :dark="!rightBtnDisabled" depressed :disabled="rightBtnDisabled" @click="$emit('rightBtnClicked')") {{ rightBtnText }}
    slot(v-else name="bottomView")
</template>

<script>
import StarGenerator from '@/components/review/general/StarGenerator.vue'
import ListingResponseItem from '@/components/review/listing/ListingResponseItem.vue'
import ListingAssignItem from '@/components/review/listing/ListingAssignItem.vue'
import FeedbackIconDisplay from '@/components/review/general/FeedbackIconDisplay.vue'
import Badge from '@/components/review/general/Badge.vue'

export default {
  name: 'ListingFeedbackItem',
  components: {
    StarGenerator,
    ListingResponseItem,
    ListingAssignItem,
    FeedbackIconDisplay,
    Badge
  },
  props: {
    name: {
      type: String,
      required: true 
    },
    profilePhoto: {
      type: String,
      default: null 
    },
    dateTime: {
      type: String,
      required: true 
    },
    star: {
      type: Number,
      required: true 
    },
    comment: {
      type: String,
      default: null 
    },
    response: {
      type: String,
      default: null 
    },
    rightBtnText: {
      type: String,
      required: true 
    },
    leftBtnText: {
      type: String,
      required: true 
    },
    middleBtnText: {
      type: String,
      required: true 
    },
    rightBtnDisabled: {
      type: Boolean
    },
    leftBtnDisabled: {
      type: Boolean
    },
    middleBtnDisabled: {
      type: Boolean
    },
    leftBtnTooltipText: {
      type: String,
      default: null
    },
    existingPatientBadge: {
      type: Boolean
    },
    overrideBottomView: {
      type: Boolean
    },
    responseType: {
      type: String,
      required: true,
      validator(value) {
        return ['googleReview', 'feedback'].includes(value)
      }
    },
    isDeletingResponse: {
      type: Boolean
    },
    isEditingResponse: {
      type: Boolean
    },
    extra_fields_data: {
      type: Array,
      default: null
    },
    labels: {
      type: Array
    }
  },
  computed: {
    isLargerScreen() {
      return this.$vuetify.breakpoint.xl
    },
    isMobileScreen () {
      return this.$vuetify.breakpoint.xs
    },
  },
  methods: {
    processAddress(value) {
      const items = []
      if (value.address_1) {
        items.push(value.address_1)
      }
      if (value.address_2) {
        items.push(value.address_2)
      }
      if (value.city) {
        items.push(value.city)
      }
      if (value.postcode) {
        items.push(value.postcode)
      }
      if (value.state) {
        items.push(value.state)
      }
      return items.join(', ')
    }
  },
}
</script>

<style scoped>
</style>
